module.exports = __webpack_public_path__ + "img/15.missing_soap.5bf0c1e0.svg";